import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GetAgentsResponse, InputExample } from '@/domains/home/apis/home-api';

export interface TrizUploadParams {
    work_project_id: string;
    work_project_item_id: string;
}

export interface CreateTrizJobParams {
    message?: string;
    upload?: TrizUploadParams;
}

export interface HomeRdApi {
    getRecommendCases(): Promise<InputExample[]>;
    getRdCards(): Promise<GetAgentsResponse>;
    createTrizJob(params: CreateTrizJobParams): Promise<{ triz_mind_id: string; }>;
}

export const HomeRdApi = Symbol('HomeRdApi');

@injectable()
export class HomeRdApiImpl extends PsHttpService implements HomeRdApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getRecommendCases() {
        return this.get<PatSnapCommonResponseData<InputExample[]>>({
            url: '/eureka/rd-home-page/rd-recommend-cases',
            method: 'GET',
        }).then((res) => {
            return res?.data as unknown as InputExample[];
        });
    }

    getRdCards() {
        return this.get<PatSnapCommonResponseData<GetAgentsResponse>>({
            url: '/eureka/rd-home-page/rd-cards',
            method: 'GET',
        }).then((res) => {
            return res?.data as unknown as GetAgentsResponse;
        });
    }

    /**
     * 创建一个TRIZ任务
     */
    createTrizJob(params: CreateTrizJobParams) {
        return this.post<PatSnapCommonResponseData<{ triz_mind_id: string; }>>({
            url: '/eureka/triz-mind/create',
            data: params,
        }).then((res) => {
            return res.data as { triz_mind_id: string; };
        });
    }
}
